import React from 'react';
import CoursesBanner from './CoursesBanner/CoursesBanner';
import CoursesTestimonials from './CoursesTestimonials/CoursesTestimonials';
import Specialization from './Specialization/Specialization';
import Testimonials from './TestimonialsSection/Testimonials';
import AllCourses from './AllCourses/AllCourses';

function Courses() {
    return (
        <>
            <CoursesBanner />
            <CoursesTestimonials/>
            <AllCourses/>
            <Specialization/>
            <Testimonials/>
        </>
    )
}

export default Courses
